__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@trayio/app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@trayio/shared-http-client", "0.0.1", () => (Promise.all([__webpack_require__.e(4945), __webpack_require__.e(1635), __webpack_require__.e(2789)]).then(() => (() => (__webpack_require__(82789))))));
			register("react-dom", "16.14.0", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(5228), __webpack_require__.e(9982), __webpack_require__.e(3441)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-query", "3.39.3", () => (Promise.all([__webpack_require__.e(5942), __webpack_require__.e(3441), __webpack_require__.e(5301)]).then(() => (() => (__webpack_require__(75942))))));
			register("react-redux", "7.1.3", () => (Promise.all([__webpack_require__.e(4146), __webpack_require__.e(3546), __webpack_require__.e(311), __webpack_require__.e(3058), __webpack_require__.e(3441), __webpack_require__.e(5301)]).then(() => (() => (__webpack_require__(53058))))));
			register("react-router-dom", "5.1.2", () => (Promise.all([__webpack_require__.e(8587), __webpack_require__.e(4422), __webpack_require__.e(4625), __webpack_require__.e(3441), __webpack_require__.e(488)]).then(() => (() => (__webpack_require__(54625))))));
			register("react-router", "5.1.2", () => (Promise.all([__webpack_require__.e(4146), __webpack_require__.e(8587), __webpack_require__.e(4422), __webpack_require__.e(4180), __webpack_require__.e(3441)]).then(() => (() => (__webpack_require__(24180))))));
			register("react", "16.14.0", () => (Promise.all([__webpack_require__.e(6540), __webpack_require__.e(5228)]).then(() => (() => (__webpack_require__(96540))))));
			register("styled-components", "5.3.11", () => (Promise.all([__webpack_require__.e(4146), __webpack_require__.e(5606), __webpack_require__.e(2833), __webpack_require__.e(4472), __webpack_require__.e(3441)]).then(() => (() => (__webpack_require__(54472))))));
			initExternal(29215);
			initExternal(68735);
			initExternal(32547);
			initExternal(83755);
			initExternal(51503);
			initExternal(88759);
			initExternal(92655);
			initExternal(73361);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};